interface SecondaryButtonProps {
  children: React.ReactNode;
  type?: "button" | "submit" | "reset" | undefined;
  onClick: () => void;
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  onClick,
  children,
  type,
}) => {
  return (
    <button
      onClick={onClick}
      type={type || "button"}
      className="w-full h-min rounded-md border border-blue-400 text-blue-400 font-bold px-4 py-2 hover:bg-blue-600 hover:text-white"
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
